export function omit(obj, ...props) {
    props = props.flat(Infinity)
    const output = { ...obj }
    props.forEach((p) => {
        delete output[p]
    })
    return output
}
